import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { Components } from './components';
import { AccountModule, AuthModule } from '@argalis-apps/angular-core';
import { AppRoutingModule } from './app-routing.module';
import { accountModuleConfig, authModuleConfig, globalModuleConfig } from './app-module-map';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { ReactiveFormsModule } from '@angular/forms';
import { GlobalModule } from '@argalis-apps/angular-global';
import { GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ContextMenuModule, MenuModule, MenusModule } from '@progress/kendo-angular-menu';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ServicesModule } from '@argalis-apps/angular-services';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { NotificationModule } from '@progress/kendo-angular-notification';
import localeFr from '@angular/common/locales/fr';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { CalendarComponent } from './components/calendar/calendar.component';
import { LabelModule } from "@progress/kendo-angular-label";
import '@progress/kendo-angular-intl/locales/fr/all';

registerLocaleData(localeFr, 'fr');
@NgModule({
  declarations: [AppComponent, ...Components, CalendarComponent],
  imports: [
    AccountModule.forRoot(accountModuleConfig),
    AppRoutingModule,
    AuthModule.forRoot(authModuleConfig),
    BrowserAnimationsModule,
    BrowserModule,
    ButtonsModule,
    ContextMenuModule,
    DateInputsModule,
    DialogsModule,
    ExcelExportModule,
    DropDownsModule,
    GlobalModule.forRoot(true, globalModuleConfig),
    GridModule,
    InputsModule,
    LayoutModule,
    MenuModule,
    MenusModule,
    NotificationModule,
    PopupModule,
    ReactiveFormsModule,
    RouterModule,
    ServicesModule,
    SchedulerModule,
    TreeViewModule,
    LabelModule,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'fr'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
